import type { TagsListProps } from './TagsList.typed';
import { FreeHistoryReportTag } from '../../Toolkit/Tags/PreBuilt/FreeHistoryReportTag';
import { GreenLightTag } from '../../Toolkit/Tags/PreBuilt/GreenlightTag';
import { Tag } from '../../Toolkit/Tags/Tag';
import * as Styled from '../../../components/AdCard/TagsList/TagsList.styled';
import {
  FEATURE_PRICING_INDICATOR,
  FEATURE_FREE_HISTORY_CHECK,
} from '../../../utils';

const TagsList = ({ tags, className }: TagsListProps) => (
  <Styled.Container className={className}>
    {tags?.map(({ displayName, type }) => {
      if (type === 'greenlight') {
        return <GreenLightTag key={displayName} />;
      }

      if (!FEATURE_PRICING_INDICATOR && type === 'freeHistoryReport') {
        return FEATURE_FREE_HISTORY_CHECK ? (
          <FreeHistoryReportTag key={displayName} />
        ) : null;
      }
      return (
        <Tag key={displayName} text={displayName} textColor={'GREY_DARK'} />
      );
    })}
  </Styled.Container>
);

export { TagsList };
